import React from "react";
import Event from "airports/p11v5-nsru-api-gen6/Event";
import NewsPage from "project-components/pages/NewsPage";
import Card from "reactstrap/lib/Card";
import CardHeader from "reactstrap/lib/CardHeader";
import CardBody from "reactstrap/lib/CardBody";
import {CardFooter, Col, Row} from "reactstrap";
import { Link } from "react-router-dom";

class Read extends React.Component
{
    constructor(props) {
        super(props)
        this.eventId = props.match.params.eventId
        this.state = {
            id: "",
            title: "{title}",
            cover: "",
            detail: "{detail}",
            photos: []
        }
    }

    async readData()
    {
        const airportEvent = new Event()
        const event = await airportEvent.read(1, this.eventId)
        this.setState({
            id: event.id,
            title: event.title,
            cover: event.cover,
            detail: event.detail,
            photos: event.photos
        })
        // newsApi.showNews(this.newsId, res => {
        //     const coverLink = process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + res.cover.replaceAll('\\', '/')
        //     this.setState({
        //         id: res.id,
        //         cover: process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + res.cover.replaceAll('\\', '/'),
        //         title: res.title,
        //         detail: res.detail
        //     })
        //     NewsCategoryApi.show(res.news_category_id, resNewsCat => {
        //         this.setState({
        //             newsCategoryName: resNewsCat.name
        //         })
        //     })
        // })
    }

    componentDidMount()
    {
        this.readData();
    }

    render() {
        return (
            <>
                <NewsPage
                    title = { this.state.title }
                    subtitle = {""}
                    leftSide = {
                        <>
                            {/* <NewsDisplay1 key={this.newsId} id={this.newsId} /> */}
                            <Card style={{
                                overflow: "hidden"
                            }}>
                                <CardHeader className="d-flex align-items-center" style={{
                                    backgroundColor: "#B7EDAD",
                                    padding: "10px"
                                }}>
                                    <div className="d-flex align-items-center">
                                        <div className="mx-3">
                                            <Link
                                                className="text-dark font-weight-500 g-font-mitr"
                                                to={"/th/news-view/" + this.state.id}
                                                style={{
                                                    fontSize: "18px"
                                                }}
                                            >
                                                {this.state.title}
                                            </Link>
                                            <small className="d-block text-muted">{this.state.createdDate}</small>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody style={{
                                    padding: "12px"
                                }}>
                                    {/* { renderDetail() } */}
                                    {/* { renderCover() } */}
                                    {/* { renderAttachmentPanel() } */}
                                    <Row>
                                        {this.state.photos.map(function (photo) {
                                            return (
                                                <>
                                                    <Col xs="4" className="mt-2 mb-2">
                                                        <img src={photo} />
                                                    </Col>
                                                </>
                                            )
                                        })}
                                    </Row>
                                    

                                </CardBody>
                                <CardFooter style={{
                                    borderTop: "1px solid #BBB",
                                    padding: "12px"
                                }}>
                                    <Row>
                                        <Col xs="12" style={{
                                            textAlign: "right",
                                            fontSize: "11px"
                                        }}>
                                            หมวดหมู่: <a href={"/th/news-portal/" + this.state.newsCategoryId}>{this.state.newsCategoryName}</a>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </>
                    }
                    rightSide={
                        <>
                            {/* <BlogCard1 /> */}
                        </>
                    }
                />
            </>
        );
    }
}

export default Read;
